import React, { useState } from "react";
import { makeAPI } from "../../services/api";

const ENGINES = [
  "Unity",
  "Cocos2d",
  "Playcanvas",
  "Away-js",
  "Babylon-js",
  "Booty5",
  "Construct-2",
  "Construct-3",
  "Create-js",
  "Defold",
  "Fancade",
  "Flash",
  "Gamemaker",
  "Gdevelop",
  "Gideros",
  "Godot",
  "Haxe",
  "Haxeflixel",
  "Impact-js",
  "Layabox",
  "Native-javascript",
  "Phaser",
  "Pixi-js",
  "Ruffle",
  "Solar2d",
  "Stencyl",
  "Three-js",
  "Tingly",
  "Other",
];

const SubmitYourGame = () => {
  document.title = "Game Submit - CGES.CLUB";
  return <RequestForm />;
};

export default SubmitYourGame;

function RequestForm() {
  const [validated, setValidated] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    link: "",
    engine: "",
    info: "",
    name: "",
    email_id: "",
    studio_name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const scrollToFirstError = (form) => {
    const firstInvalid = form.querySelector(
      "input:invalid, textarea:invalid, select:invalid"
    );
    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      firstInvalid.focus();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      setValidated(true);
      scrollToFirstError(form);
      return;
    }

    const reportData = { data: formData };

    try {
      setSubmitting(true);
      const apiData = await makeAPI("/api/share_your_game", "POST", false, reportData);

      if (!apiData || apiData.status !== "S") {
        alert("Failed to save. Try again after sometime.");
        return;
      }

      try {
        await fetch("https://n8n.chennaigames.com/webhook/submit-game", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reportData),
        });
      } catch (err) {
        console.error("Webhook submission failed:", err);
      }

      setSubmitted(true);
    } catch (err) {
      console.error("Submit game failed:", err);
      alert("Network error. Please try again.");
    } finally {
      setSubmitting(false);
      setValidated(true);
    }
  };

  return (
    <>
      <style>
        {`
        .submit-game-shell {
          max-width: 980px;
         
        }

        .dark-card {
          background-color: #161616;
          color: #e4e4e4;
          border: 1px solid #2a2a2a;
          border-radius: 16px;
        }

        .dark-shadow {
          box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35);
        }

        .form-head-block {
          padding-bottom: 16px;
          margin-bottom: 18px;
          border-bottom: 1px solid #2f2f2f;
        }

        .form-head-block h1 {
          font-size: clamp(1.2rem, 2.8vw, 1.9rem);
          font-weight: 700;
          margin: 0 0 10px;
          color: #ffffff;
        }

        .form-head-block p {
          margin: 0;
          color: #d6d6d6;
          line-height: 1.7;
          font-size: clamp(0.9rem, 1.8vw, 1.02rem);
        }

        .section-title {
          color: #ff810e;
          border-bottom: 1px solid #2f2f2f;
          padding-bottom: 8px;
          margin-top: 2rem !important;
          margin-bottom: 1rem;
        }

        .dark-card form label:not(.form-check-label) {
          display: inline-block;
          margin-bottom: 0.45rem;
          line-height: 1.4;
          font-weight: 500;
        }

        .dark-input {
          background-color: #000 !important;
          color: #e4e4e4 !important;
          border: 1px solid #333333;
          min-height: 44px;
        }

        .dark-input::placeholder {
          color: #797979 !important;
          opacity: 1;
        }

        .dark-input:focus {
          border-color: #ff810e;
          box-shadow: 0 0 0 0.18rem rgba(255, 129, 14, 0.2);
        }

        .help-text {
          color: #a8a8a8;
          font-size: 0.84rem;
          margin-top: 0.45rem;
        }

        .dark-card form .mb-3,
        .dark-card form .row {
          margin-bottom: 1rem !important;
        }

        .btn-orange {
          background-color: #ff810e;
          border: none;
          color: #fff;
          font-weight: 600;
          min-height: 44px;
          padding: 10px 24px;
          margin-top: 1.6rem !important;
        }

        .btn-orange:hover {
          background-color: #e6730c;
          color: #fff;
        }

        .thank-you-box {
          background: #161616;
          color: #e4e4e4;
          padding: 40px 24px;
          border-radius: 10px;
          text-align: center;
          border: 1px solid #2f2f2f;
        }

        .thank-you-box h3 {
          color: #ff810e;
        }

        @media (max-width: 768px) {
          .submit-game-shell {
          
            margin-bottom: 1.5rem !important;
          }

          .dark-card {
            padding: 18px !important;
          }

          .form-head-block {
            margin-bottom: 14px;
            padding-bottom: 12px;
          }

          .section-title {
            margin-top: 1.5rem !important;
          }
        }
        `}
      </style>

      <div className="container mt-5 mb-5 submit-game-shell">
        <div className="card dark-card dark-shadow p-4">
          <div className="form-head-block">
            <h1>Submit Your Game</h1>
            <p>
              Share your game details with CGES.CLUB. We review each submission for possible
              listing, testing, and collaboration opportunities.
            </p>
          </div>

          {!submitted ? (
            <form
              noValidate
              className={validated ? "was-validated" : ""}
              onSubmit={handleSubmit}
            >
              <h5 className="section-title">1. About Your Game</h5>

              <div className="mb-3">
                <label htmlFor="title">
                  Game Title <span className="text-danger">*</span>
                </label>
                <input
                  id="title"
                  name="title"
                  className="form-control dark-input"
                  type="text"
                  placeholder="Enter the title of your game"
                  minLength={3}
                  maxLength={50}
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="link">
                  Game Link / Google Drive Link <span className="text-danger">*</span>
                </label>
                <input
                  id="link"
                  name="link"
                  type="url"
                  className="form-control dark-input"
                  placeholder="https://yourgame.link"
                  value={formData.link}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="engine">
                  Game Engine <span className="text-danger">*</span>
                </label>
                <select
                  id="engine"
                  name="engine"
                  className="form-select dark-input"
                  value={formData.engine}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Select an engine
                  </option>
                  {ENGINES.map((engine) => (
                    <option key={engine} value={engine.toLowerCase()}>
                      {engine}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label htmlFor="info">
                  More Information About Your Game <span className="text-danger">*</span>
                </label>
                <textarea
                  id="info"
                  name="info"
                  className="form-control dark-input"
                  rows="5"
                  placeholder="Tell us more about your game (up to 1000 characters)"
                  maxLength={1000}
                  value={formData.info}
                  onChange={handleChange}
                  required
                />
                <div className="help-text">
                  Include summary, platform compatibility, file size, and key features.
                </div>
              </div>

              <h5 className="section-title">2. About You</h5>

              <div className="mb-3">
                <label htmlFor="name">
                  Your Name <span className="text-danger">*</span>
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control dark-input"
                  placeholder="Enter your name"
                  maxLength={100}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="email_id">
                  Your Email Address <span className="text-danger">*</span>
                </label>
                <input
                  id="email_id"
                  name="email_id"
                  type="email"
                  className="form-control dark-input"
                  placeholder="Enter your email address"
                  maxLength={150}
                  value={formData.email_id}
                  onChange={handleChange}
                  required
                />
                <div className="help-text">We will only use this to contact you about this game.</div>
              </div>

              <div className="mb-3">
                <label htmlFor="studio_name">
                  Studio or Developer Name <span className="text-danger">*</span>
                </label>
                <input
                  id="studio_name"
                  name="studio_name"
                  type="text"
                  className="form-control dark-input"
                  placeholder="Enter your studio or developer name"
                  maxLength={120}
                  value={formData.studio_name}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-orange" disabled={submitting}>
                {submitting ? "Submitting..." : "Submit Game"}
              </button>
            </form>
          ) : (
            <div className="thank-you-box">
              <h3>Thank You for Submitting</h3>
              <p>We received your game details and will get back to you after review.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
